var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoAccess(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 92,
    viewBox: "0 0 88 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M37.8744 79.0097C58.7919 79.0097 75.7488 61.3228 75.7488 39.5049C75.7488 17.6869 58.7919 0 37.8744 0C16.957 0 0 17.6869 0 39.5049C0 61.3228 16.957 79.0097 37.8744 79.0097Z",
    fill: "url(#paint0_linear_9640_18476)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.1707 67.7188L64.9081 62.7773L77.8396 76.2655L73.1021 81.2069L60.1707 67.7188Z",
    fill: "url(#paint1_linear_9640_18476)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.3045 76.9373L73.7621 71.2448C74.5542 70.4184 75.8504 70.4184 76.6427 71.2448L87.4059 82.4713C88.198 83.2976 88.198 84.6496 87.4059 85.476L81.9484 91.1685C81.1562 91.9947 79.86 91.9947 79.0677 91.1685L68.3045 79.9419C67.5124 79.1157 67.5124 77.7635 68.3045 76.9373Z",
    fill: "url(#paint2_linear_9640_18476)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.5508 76.6789L73.7608 71.2448C74.5529 70.4184 75.8491 70.4184 76.6414 71.2448L87.4046 82.4713C88.1967 83.2976 88.1967 84.6496 87.4046 85.476L82.9871 90.0836C82.1956 90.4241 81.2475 90.2602 80.6069 89.5921L69.0751 77.5639C68.8288 77.3072 68.654 77.003 68.5508 76.6789Z",
    fill: "url(#paint3_linear_9640_18476)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1570"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.8803 18.1953C43.0756 18.1953 47.2872 22.588 47.2872 28.0067C47.2872 33.4256 43.0756 37.8185 37.8803 37.8185C32.6853 37.8185 28.4739 33.4258 28.4739 28.0067C28.4737 22.5882 32.6853 18.1953 37.8803 18.1953Z",
    fill: "url(#paint4_linear_9640_18476)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.753 37.5684C31.5827 36.5627 28.4739 32.6644 28.4739 28.0086C28.4739 23.3532 31.5827 19.455 35.753 18.4492C39.9235 19.455 43.0323 23.3532 43.0323 28.0086C43.0323 32.6644 39.9235 36.5627 35.753 37.5684Z",
    fill: "url(#paint5_linear_9640_18476)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.3399 71.4159C44.0927 77.1793 31.6637 77.1793 21.4165 71.4159V54.9909C21.4165 45.5467 28.8242 37.8203 37.8782 37.8203C46.9323 37.8203 54.3399 45.5469 54.3399 54.9909V71.4159Z",
    fill: "url(#paint6_linear_9640_18476)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.4072 75.643C30.5723 75.285 25.7953 73.8755 21.4165 71.4126V54.9876C21.4165 46.4191 27.5145 39.2648 35.4072 38.0117C43.3 39.2648 49.3979 46.4191 49.3979 54.9876V71.4126C45.0191 73.8755 40.2421 75.285 35.4072 75.643Z",
    fill: "url(#paint7_linear_9640_18476)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.4714 65.55C38.4714 66.3004 37.8882 66.9087 37.1689 66.9087C36.4491 66.9087 35.8663 66.3021 35.8663 65.5447C35.8663 64.7944 36.4495 64.1861 37.1689 64.1861C37.8886 64.1861 38.4714 64.7927 38.4714 65.55ZM33.9103 47.7765C33.4354 48.3364 32.6153 48.3886 32.0785 47.8933C31.5419 47.398 31.4916 46.5426 31.9665 45.9827C34.6214 42.8567 39.2476 42.6989 42.0866 45.6601C45.7293 49.4596 44.2685 55.9035 39.4365 57.6433C38.8384 57.8587 38.4712 58.3983 38.4712 59.0653V60.4433C38.4712 61.1936 37.888 61.8019 37.1687 61.8019C36.4493 61.8019 35.8661 61.1936 35.8661 60.4433C35.8661 58.9851 35.7431 57.8866 36.6114 56.6158C37.0859 55.9216 37.7656 55.3828 38.592 55.0851C41.6107 53.9982 42.5228 49.9571 40.245 47.5812C38.4678 45.7277 35.5638 45.8317 33.9103 47.7765Z",
    fill: "#0C66E4"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0931 11.5707C25.8839 -3.85688 49.8647 -3.85688 64.6555 11.5707C79.4463 26.9982 79.4463 52.0113 64.6555 67.4389C49.8647 82.8664 25.8839 82.8664 11.0931 67.4389C-3.6977 52.0113 -3.6977 26.9982 11.0931 11.5707ZM16.4319 17.1392C4.387 29.7026 4.387 50.0721 16.4319 62.6357C28.4767 75.1991 48.0055 75.1991 60.0504 62.6357C72.0953 50.0723 72.0953 29.7028 60.0504 17.1395C48.0055 4.57585 28.4767 4.57585 16.4319 17.1392Z",
    fill: "url(#paint8_linear_9640_18476)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9640_18476",
    x1: 11.3192,
    y1: 17.3215,
    x2: 66.3917,
    y2: 65.4302,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9F3FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9640_18476",
    x1: 65.7473,
    y1: 73.5037,
    x2: 71.7612,
    y2: 69.0156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9F3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CADCF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_9640_18476",
    x1: 47.2067,
    y1: 93.7182,
    x2: 88.2142,
    y2: 93.7182,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_9640_18476",
    x1: 48.8975,
    y1: 92.0464,
    x2: 88.204,
    y2: 92.0464,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_9640_18476",
    x1: 9.46187,
    y1: 39.6082,
    x2: 47.4859,
    y2: 39.6082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_9640_18476",
    x1: 13.7617,
    y1: 39.3121,
    x2: 43.186,
    y2: 39.3121,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_9640_18476",
    x1: 21.4171,
    y1: 56.7794,
    x2: 54.3401,
    y2: 56.7794,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9F3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CADCF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_9640_18476",
    x1: 21.417,
    y1: 56.8274,
    x2: 49.3981,
    y2: 56.8274,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9F3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CADCF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_9640_18476",
    x1: 24.6945,
    y1: 5.91232,
    x2: 49.472,
    y2: 81.7011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BBDB"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoAccess);
export default __webpack_public_path__ + "static/media/noAccess.533cf87e9e37e9694372bce83c9c48d4.svg";
export { ForwardRef as ReactComponent };